import { restApiMP } from "@plannel/services/utils/rest-api";

const getInventoryWip = params => {
  return restApiMP.post("/api/inventory-wip", params);
};

const getInventoryWipTracking = params => {
  return restApiMP.get("/api/inventory-wip-tracking", { params });
};
  
const getInventoryWipTotal = params => {
  return restApiMP.get("/api/inventory-wip-total", { params });
};

const inventoryWipTrackingService = {
  getInventoryWip,
  getInventoryWipTracking,
  getInventoryWipTotal,
};

export default inventoryWipTrackingService;